import { render } from "./ChatDialog.vue?vue&type=template&id=cdc62bd4"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__